import $ from 'jquery'

/**
 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
 * @param subjectString
 * @param searchString
 * @param position
 * @returns {boolean}
 */
function endsWith(subjectString, searchString, position)
{
	if(typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length)
	{
		position = subjectString.length
	}

	position -= searchString.length

	const lastIndex = subjectString.indexOf(searchString, position)
	return lastIndex !== -1 && lastIndex === position
}

const assetExtensions =  'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ')

export default function(context = document.body)
{
	const $context = $(context)

	// Forces new window clicks for asset files
	$context.find('a').each(function()
	{
		const $this = $(this)
		const href = String($this.attr('href')).toLowerCase()

		for(let ext of assetExtensions)
		{
			if(endsWith(href, '.' + ext))
			{
				$this.attr('target', '_blank')
				break
			}
		}
	})

	// Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
	$context.find('a, button').on('click', function()
	{
		$(this).trigger('blur')
	})
}



// WEBPACK FOOTER //
// ./source/scripts/components/links.js